import { FormFieldWidget, ModelFieldType, SPI, ViewType, Widget } from '@kunlun/dependencies';
import StringPropertiesPanel from './Component/StringPropertiesPanel.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.String,
    widget: 'CreditRuleAttrPanelField',
  })
)
export class CreditRuleAttrPanelFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(StringPropertiesPanel);
    return this;
  }
}
